// extracted by mini-css-extract-plugin
export default {"WishChart":"WishChart_WishChart__WJw+0"};